import { BitkitLabel } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';

import { PublicApiBuild } from '@/models/Build';

type BuildPriorityProps = {
  build: PublicApiBuild;
  label?: boolean;
};

const BuildPriority = ({ build, label = true }: BuildPriorityProps) => {
  const params = build.originalBuildParams || build.triggerParams;

  if (params?.priority === undefined || params?.priority === 0) {
    return null;
  }

  return (
    <>
      {params?.priority !== undefined && params?.priority !== 0 && (
        <Box display="flex" flexDir="column">
          {label && <BitkitLabel>Priority</BitkitLabel>}
          <Text textStyle="body/md/regular" color={label ? 'text/body' : 'text/secondary'}>
            {params?.priority} ({params?.priority > 0 ? 'High' : 'Low'})
          </Text>
        </Box>
      )}
    </>
  );
};

export default BuildPriority;
